import { render, staticRenderFns } from "./TipsDesglose.vue?vue&type=template&id=71421571&scoped=true&"
import script from "./TipsDesglose.vue?vue&type=script&lang=js&"
export * from "./TipsDesglose.vue?vue&type=script&lang=js&"
import style0 from "./TipsDesglose.vue?vue&type=style&index=0&id=71421571&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71421571",
  null
  
)

export default component.exports